@if (assets().length) {
  <div class="assets-grid">
    @for (asset of assets(); track asset.id) {
      <div
        class="asset-item"
        (click)="facade.insertAssetRef(asset.id)"
        (mouseenter)="facade.hoveredAsset.set(asset)"
        (mouseleave)="facade.hoveredAsset.set(null)"
      >
        <app-asset [asset]="asset" mode="thumbnail"/>
      </div>
    }
  </div>
}
